import React from 'react'

const arrowRight = () => (
  <svg width="32" height="32" viewBox="0 0 32 32" xmlns="http://www.w3.org/2000/svg">
    <path fillRule="evenodd" clipRule="evenodd" d="M-4.80825e-07 16C-5.01252e-07 15.5327 0.401623 15.1538 0.897051 15.1538L28.4819 15.1538L18.9059 6.45566C18.549 6.13151 18.5383 5.59585 18.8819 5.25923C19.2256 4.92261 19.7935 4.9125 20.1503 5.23665L32 16L20.1503 26.7633C19.7935 27.0875 19.2256 27.0774 18.8819 26.7408C18.5383 26.4042 18.549 25.8685 18.9059 25.5443L28.4819 16.8462L0.897051 16.8462C0.401623 16.8462 -4.60398e-07 16.4673 -4.80825e-07 16Z"/>
  </svg>
)

export default arrowRight
